import {
    ChangeDetectionStrategy, Component, computed, contentChild, forwardRef, input, model, output, Signal, TemplateRef, ViewEncapsulation
} from "@angular/core";
import { Wrapper } from "../wrapper.interface";
import { FileUploadListConfig } from "./fileUpload-list.config";
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { WRAPPER_TOKEN } from "../wrapper.tokens";
import { TranslateModule } from "@ngx-translate/core";
import { CdkDrag, CdkDragDrop, CdkDragHandle, CdkDropList, moveItemInArray } from "@angular/cdk/drag-drop";
import { UploadFile } from "../fileUpload/interfaces";
import { GcLayoutModule } from "src/app/components/v-layout/layout.module";
import { GcInfoComponent } from "src/app/components/v-info/v-info.component";
import { VIconComponent } from "src/app/components/v-icon/v-icon.component";

@Component({
    selector:    'v-fileUpload-list',
    templateUrl: './fileUpload-list.component.haml',
    styleUrls:   ['./fileUpload-list.component.sass', '../input.style.sass'],
    providers:   [
        { provide: WRAPPER_TOKEN, useExisting: forwardRef(() => VFileUploadListComponent) },
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => VFileUploadListComponent), multi: true }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation:   ViewEncapsulation.None,
    standalone:      true,
    imports:         [CommonModule, ReactiveFormsModule, TranslateModule, CdkDropList, CdkDrag, CdkDragHandle, VIconComponent, GcLayoutModule, GcInfoComponent],
})
export class VFileUploadListComponent<T extends UploadFile>  extends Wrapper<FileUploadListConfig> {
    protected readonly _baseConfig: FileUploadListConfig = FileUploadListConfig.baseTheme.Default;
    selectedFiles = model<T[]>([]);
    allowDrag = input<boolean>(true);
    selectedFilesChange = output<T[]>();

    public isEmpty = computed(() => this.selectedFiles().length === 0);
    public emptyTemplateRef: Signal<TemplateRef<unknown>> = contentChild("empty");
    public previewTemplateRef: Signal<TemplateRef<unknown>> = contentChild("preview");
    public detailTemplateRef: Signal<TemplateRef<unknown>> = contentChild("detail");

    get orientationClass() {
        return `orientation-${this.config().orientation}`;
    }

    getFileSize(size: number): string {
        return (size / (1024 * 1024)).toFixed(2).replace('.', ',') + ' MB';
    }

    removeFileAt(index: number): void {
        const files = [...this.selectedFiles()];
        files.splice(index, 1);
        this.selectedFiles.set(files);
        this.emitSelectedFileChange();
    }

    moveItem(currentIndex: number, newIndex: number): void {
        const files = [...this.selectedFiles()];
        moveItemInArray(files, currentIndex, newIndex);
        this.selectedFiles.set(files);
        this.emitSelectedFileChange();
    }

    drop(event: CdkDragDrop<string[]>) {
        this.moveItem(event.previousIndex, event.currentIndex);
    }

    emitSelectedFileChange(): void {
        this.selectedFilesChange.emit(this.selectedFiles());
    }
}